<div>
    <div class="head-title">
        <div class="left">
          <h3>{{projectInfos['belongs'].join(' - ')}} (Structure: {{projectInfos['id_structure']}})</h3>
        </div>
    </div>
    <div fxLayout="row" style="padding: 20px 10px 20px 10px;">
        <div class="center-vertical" fxFlex="20%">
            <p>Total: {{this.showedRows.length}}</p>
        </div>
        <div class="center-vertical" fxFlex="40%" fxLayoutAlign="center center">
            <button type="button" class="button-secondary-small" (click)="contentsSetting()"  style="white-space: nowrap; align-items: center; display: flex; margin-right: 3px;">
                <mat-icon fontIcon="settings" style="color: gray; cursor: pointer; margin-right: 5px; font-size: 20px; width: fit-content; height: fit-content;"></mat-icon>
                <div>Setting Content</div>
            </button>
        </div>
        <div class="center-vertical" fxFlex="40%" style="display: flex; align-items: center;">
            <div style="margin-left: auto;">
                <input class="col-input"  (keyup)="applyFilterLocal($event.target, 'all_column')" placeholder="Search">
            </div>
        </div>
    </div>
    <div *ngIf="platformInfos['origin'] == 'virtualcampus'" class="table_div" style="height: 80vh;">
        <table>
            <thead>
            <tr>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id_project', 'number')"></mat-icon>
                    <div class="column-name">Id Project</div>
                    <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id_project')">
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id_content', 'number')"></mat-icon>
                    <div class="column-name">Id Content</div>
                    <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id_content')">
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'department', 'string')"></mat-icon>
                    <div class="column-name">Department</div>
                    <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'department')">
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'semester', 'string')"></mat-icon>
                    <div class="column-name">Semester</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'semester')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'module', 'string')"></mat-icon>
                    <div class="column-name">Module</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'module')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'year', 'string')"></mat-icon>
                    <div class="column-name">Year / Name</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'year')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'section', 'string')"></mat-icon>
                    <div class="column-name">Section</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'section')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'type', 'string')"></mat-icon>
                    <div class="column-name">Type / Chapter</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'type')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'state', 'string')"></mat-icon>
                    <div class="column-name">State</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'state')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'active', 'string')"></mat-icon>
                    <div class="column-name">Active</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'active')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'source', 'string')"></mat-icon>
                    <div class="column-name">Source</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'source')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'status', 'string')"></mat-icon>
                    <div class="column-name">Status</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'status')"></div>
                </th>
                <th>
                    <div style="display: flex; justify-content: center;"><input #checkedAllRef type="checkbox" class="form-check-input" style="font-size:large; cursor: pointer;" (change)="selectAllOption($event.target)"></div>
                </th>
            </tr>
            </thead>
            <tbody #row_tbody *ngFor="let row of showedRows; let i = index">
                <tr (click)="toggleRow(row, $event.target, row_tbody)" [ngClass]="{'highlight-previous': row['source'] !='project'}">
                    <td>{{ row['id_project'] }}</td>
                    <td>{{ row['id_content'] }}</td>
                    <td matTooltip="{{ row['department'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['department'] }}</td>
                    <td>{{ row['semester'] }}</td>
                    <td>{{ row['module'] }}</td>
                    <td style="white-space: nowrap;" matTooltip="{{ row['year_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['year_name'] }}</td>
                    <td>{{ row['section'] }}</td>
                    <td >{{ row['type_chapter']}}</td>
                    <td [innerHTML]="row['state_format']"></td>
                    <td [innerHTML]="row['active_format']"></td>
                    <td >{{ row['source']}}</td>
                    <td >{{ row['status']}}</td>
                    <td class="to_skip_element select_container">
                        <div *ngIf="row['nb_duplicate'] > 1 && row['source'] == 'project' && row['status'] != 'archived' && row['id_content_replace'] == null" class="duplicate-mark"></div>
                        <div style="display: flex;">
                            <input type="checkbox" class="form-check-input" style="font-size:large; cursor: pointer;" [disabled]="row['source']=='content'" (change)="selectRow($event.target, i)" [checked]="row['checked']">
                            <mat-icon sorted="" fontIcon="more_vert" style="color: gray; font-size: 20px;" (click)="contentOption(row)"></mat-icon>
                        </div>
                    </td>
                </tr>
                <tr class="expand_detail" *ngIf="row['expanded']">
                    <td colspan="14">
                        <app-vca-detail-content [rowInfos]="row" [userInfos]="userInfos" [projectInfos]="projectInfos" (inProgress)="setWaiting($event)" (updateStates)="setUpdatedContent($event, platformInfos.key)" (updateContent)="setUpdatedContent($event, platformInfos.key)"></app-vca-detail-content>
                    </td>
                </tr>
            </tbody>
            <tbody *ngIf="showedRows.length === 0">
                <tr ><td colspan="14" style="text-align: center;">No matching records found</td></tr>
            </tbody>
        </table>
    </div>

    <div *ngIf="platformInfos['origin'] == 'virtualclass'" class="table_div" style="height: 80vh;">
        <table>
            <thead>
            <tr>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id_project', 'number')"></mat-icon>
                    <div class="column-name">Id Project</div>
                    <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id_project')">
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id_content', 'number')"></mat-icon>
                    <div class="column-name">Id Content</div>
                    <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id_content')">
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'belongs', 'string')"></mat-icon>
                    <div class="column-name">Belongs to</div>
                    <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'belongs')">
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'class', 'string')"></mat-icon>
                    <div class="column-name">Class</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'class')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'study', 'string')"></mat-icon>
                    <div class="column-name">Study</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'study')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'module', 'string')"></mat-icon>
                    <div class="column-name">Module</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'module')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'year', 'string')"></mat-icon>
                    <div class="column-name">Year / Name</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'year')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'period', 'string')"></mat-icon>
                    <div class="column-name">Period</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'period')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'section', 'string')"></mat-icon>
                    <div class="column-name">Section</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'section')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'type', 'string')"></mat-icon>
                    <div class="column-name">Type / Chapter</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'type')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'state', 'string')"></mat-icon>
                    <div class="column-name">State</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'state')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'active', 'string')"></mat-icon>
                    <div class="column-name">Active</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'active')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'source', 'string')"></mat-icon>
                    <div class="column-name">Source</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'source')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'status', 'string')"></mat-icon>
                    <div class="column-name">Status</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'status')"></div>
                </th>
                <th>
                    <div style="display: flex; justify-content: center;"><input #checkedAllRef type="checkbox" class="form-check-input" style="font-size:large; cursor: pointer;" (change)="selectAllOption($event.target)"></div>
                </th>
            </tr>
            </thead>
            <tbody #row_tbody *ngFor="let row of showedRows; let i = index">
                <tr (click)="toggleRow(row, $event.target, row_tbody)" [ngClass]="{'highlight-previous': row['source'] !='project'}">
                    <td>{{ row['id_project'] }}</td>
                    <td>{{ row['id_content'] }}</td>
                    <td matTooltip="{{ row['belongs'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['belongs'] }}</td>
                    <td>{{ row['class'] }}</td>
                    <td>{{ row['study'] }}</td>
                    <td>{{ row['module'] }}</td>
                    <td style="white-space: nowrap;" matTooltip="{{ row['year_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['year_name'] }}</td>
                    <td style="white-space: nowrap;">{{ row['period'] }}</td>
                    <td>{{ row['section'] }}</td>
                    <td>{{ row['type_chapter']}}</td>
                    <td [innerHTML]="row['state_format']"></td>
                    <td [innerHTML]="row['active_format']"></td>
                    <td >{{ row['source']}}</td>
                    <td >{{ row['status']}}</td>
                    <td class="to_skip_element select_container">
                        <div *ngIf="row['nb_duplicate'] > 1 && row['source'] == 'project' && row['status'] != 'archived' && row['id_content_replace'] == null" class="duplicate-mark"></div>
                        
                        <div style="display: flex;">
                            <input type="checkbox" class="form-check-input" style="font-size:large; cursor: pointer;" [disabled]="row['source']=='content'" (change)="selectRow($event.target, i)" [checked]="row['checked']">
                            <mat-icon sorted="" fontIcon="more_vert" style="color: gray; font-size: 20px;" (click)="contentOption(row)"></mat-icon>
                        </div>
                    </td>
                </tr>
                <tr class="expand_detail" *ngIf="row['expanded']">
                    <td colspan="15">
                        <app-vcl-detail-content [rowInfos]="row" [userInfos]="userInfos" [projectInfos]="projectInfos" (inProgress)="setWaiting($event)" (updateStates)="setUpdatedContent($event, platformInfos.key)" (updateContent)="setUpdatedContent($event, platformInfos.key)"></app-vcl-detail-content>
                    </td>
                </tr>
            </tbody>
            <tbody *ngIf="showedRows.length === 0">
                <tr ><td colspan="14" style="text-align: center;">No matching records found</td></tr>
            </tbody>
        </table>
    </div>
</div>